export const usersStyles = () => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    addUserButtonText: {
        fontWeight: 500,
        color: '#FFF',
    },
    addUserButton: {
        padding: '12px 20px',
        height: '48px',
        '& .MuiButton-startIcon': {
            mr: '4px',
        },
    },
});

export const userFormStyles = () => ({
    customLabel: {
        fontSize: 16,
        fontWeight: 500,
        color: (theme) => (theme.palette.mode === 'dark' ? '#D3D5DA' : '#4D5461'),
    },
    cancelButton: {
        fontWeight: '500',
        fontSize: '14px',
        color: '#6C727F',
        border: (theme) =>
            theme.palette.mode === 'dark' ? '1px solid #394150' : '1px solid #E5E6EB',
        textTransform: 'none',
        marginRight: '20px',
        padding: 'auto 10px',
    },
});

export const posStyles = ({ isScreenLowerThan1024 }) => ({
    personalInformation: {
        p: isScreenLowerThan1024 ? '24px' : '32px',
        borderRadius: '12px',
        backgroundColor: (theme) => theme.backgroundColor.primary,
    },
});

export const posCardStyles = () => ({
    card: {
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#2A3240' : '#F9FAFB'),
        borderRadius: '1rem',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
    },
    logo: {
        height: 120,
        objectFit: 'contain',
        objectPosition: 'center',
        padding: '15px',
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#2A3240' : '#f8f9fa'),
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
    },
    cardContent: {
        padding: '16px',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    connectButton: {
        textTransform: 'none',
        fontWeight: 500,
        borderColor: (theme) => (theme.palette.mode === 'dark' ? '#4B5563' : '#D1D5DB'),
        color: (theme) => (theme.palette.mode === 'dark' ? '#E5E7EB' : '#374151'),
        '&:hover': {
            borderColor: (theme) => (theme.palette.mode === 'dark' ? '#9CA3AF' : '#9CA3AF'),
            backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
        },
        marginTop: '10px',
        width: '100%',
    },
});

export const skyboxModalStyles = () => ({
    datePicker: {
        '& .MuiInputBase-root': {
            backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? '#394150' : 'rgb(244, 244, 246)',
            borderRadius: '8px',
            border: 'none',
            height: '48px',
            minHeight: '40px',
            fontSize: 13,
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            '&:hover .MuiOutlinedInput-notchedOutline': {
                border: (theme) =>
                    `1px solid ${theme.palette.mode === 'dark' ? '#E5E6EB' : '#E5E6EB'}`,
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
        '& .MuiSvgIcon-root': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
        },
        '& .MuiInputBase-input::placeholder': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            opacity: 1,
            fontSize: 13,
        },
        width: '100%',
        '& .MuiInputLabel-root': { fontSize: '13px' },
        '& .MuiOutlinedInput-input': { fontSize: '13px' },
    },
});

export const billingStyles = () => ({
    billing: {
        p: '32px',
        borderRadius: '12px',
        backgroundColor: (theme) => theme.backgroundColor.primary,
    },
    mainHeading: {
        fontWeight: 700,
        fontSize: 24,
        mb: 0.5,
    },
    subHeading: {
        fontWeight: 500,
        fontSize: 14,
        color: (theme) => theme.primary.dark,
    },
    planCard: {
        p: 3,
        borderRadius: '12px',
        backgroundColor: (theme) => theme.backgroundColor.primary,
        border: '1px solid',
        borderColor: (theme) => theme.borderColor.primary,
        mb: 2,
        width: '100%',
    },
    planCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
    },
    planTitle: {
        fontWeight: 700,
        fontSize: 18,
        mb: 0.5,
    },
    planSubtitle: {
        fontWeight: 500,
        fontSize: 14,
        color: (theme) => theme.primary.dark,
    },
    planPrice: {
        fontWeight: 700,
        fontSize: 24,
    },
    featureItem: {
        display: 'flex',
        alignItems: 'center',
        mb: 1,
        '& svg': {
            color: (theme) => theme.palette.primary.main,
            mr: 1,
        },
    },
    featureText: {
        fontSize: 14,
        color: (theme) => theme.primary.dark,
    },
    usageContainer: {
        mb: 3,
    },
    usageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        mb: 1,
    },
    usageText: {
        fontSize: 12,
        color: (theme) => theme.primary.dark,
    },
    progressBar: {
        height: 6,
        borderRadius: '3px',
        backgroundColor: (theme) => theme.borderColor.primary,
        '& .MuiLinearProgress-bar': {
            backgroundColor: (theme) => theme.palette.primary.main,
            borderRadius: '3px',
        },
    },
    upgradeButton: {
        mt: 2,
    },
    cardsContainer: {
        maxWidth: '800px',
        mx: 'auto',
    },
    cardSpacing: {
        mb: 3,
    },
});

export const integrationModalStyles = () => ({
    datePicker: {
        '& .MuiInputBase-root': {
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#394150' : '#F4F4F6'),
            borderRadius: '8px',
            border: 'none',
            height: '48px',
            minHeight: '40px',
            fontSize: 13,
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            '&:hover .MuiOutlinedInput-notchedOutline': {
                border: (theme) =>
                    `1px solid ${theme.palette.mode === 'dark' ? '#E5E6EB' : '#E5E6EB'}`,
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
        '& .MuiSvgIcon-root': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
        },
        '& .MuiInputBase-input::placeholder': {
            color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
            opacity: 1,
            fontSize: 13,
        },
        width: '100%',
    },
});
